import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { CustomerLogos } from '../components/CustomerLogos';
import { FeaturesSection } from '../components/FeaturesSection';
import { VCLogos } from '../components/VCLogos';
import { CTABanner } from '../components/CTABanner';
export function HomePage() {
  return <>
      <HeroSection data-id="element-405" />
      <CustomerLogos data-id="element-406" />
      <FeaturesSection data-id="element-407" />
      <VCLogos data-id="element-408" />
      <CTABanner data-id="element-409" />
    </>;
}